import { LeadsIFrame } from "components/organisms/LeadsIFrame";

const ViewCustomer = () => {
  return <LeadsIFrame page="view" />;
};

export { ViewCustomer };
